import config from "../config";

export const GTM_NONCE = new Date().getTime();

if (config?.configGoogleTagManager?.gtmId) {
  import("react-gtm-module-nonce").then((TagManager) => {
    TagManager.default.initialize({
      ...config.configGoogleTagManager,
      nonce: GTM_NONCE,
    });
  });
}
